import RandomizeHelper from "../../../../../helpers/RandomizeHelper";
import SelectedFormView from "./SelectedFormView";

function SelectedForm({
  printerData,
  setPrinterData,
  submitError,
  fields,
  images,
}) {
  const selectedLabelItemIndex = printerData.label_items.findIndex(
    (item) => item.selected
  );
  const selectedLabelItem =
    printerData.label_items[selectedLabelItemIndex] ?? null;

  /**
   * This method will handle the deletion of selected items.
   */
  function onDelete() {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.filter((item) => !item.selected),
    }));
  }

  /**
   * This method will handle the duplication of the selected label item.
   */
  function onDuplicate() {
    setPrinterData((prev) => {
      const newItem = {
        ...selectedLabelItem,
        id: RandomizeHelper.getUUID(),
        selected: true,
      };

      const updatedItems = prev.label_items.map((item) =>
        item.id === selectedLabelItem.id ? { ...item, selected: false } : item
      );

      return {
        ...prev,
        label_items: [...updatedItems, newItem],
      };
    });
  }

  /**
   * This method will handle the close event.
   */
  function onClose() {
    setPrinterData((prev) => ({
      ...prev,
      label_selected: false,
      label_items: prev.label_items.map((item) =>
        item.selected ? { ...item, selected: false } : item
      ),
    }));
  }

  return (
    <SelectedFormView
      printerData={printerData}
      setPrinterData={setPrinterData}
      selectedLabelItemIndex={selectedLabelItemIndex}
      selectedLabelItem={selectedLabelItem}
      submitError={submitError}
      fields={fields}
      images={images}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onClose={onClose}
    />
  );
}

export default SelectedForm;
